import { useEffect , useState , useRef } from 'react'
import styles from './styles.module.sass'

const contador = 180

const CounterTimeOTP = (props) => {
    const {
        initialTime = contador,
        play,
        setReset
    } = props


    // Counter
    const [tiempo, setTiempo] = useState(initialTime)
    const [formatTime, setFormatTime] = useState()
    const intervalRef = useRef();
    

    const zero = (num) => (num < 10 ? `0${num}` : num);
    const secsToMinSecs = (totalSegundos) => {
        const minutes = Math.floor(totalSegundos / 60);
        const seconds = totalSegundos - minutes * 60;
        return `${zero(minutes)  }:${  zero(seconds)}`;
    }

    // Calcula el tiempo restante
    const startTimeRef = useRef(null);
     const calculateRemainingTime = () => {
        if (startTimeRef.current) {
            const elapsedTime = Math.floor((Date.now() - startTimeRef.current) / 1000);
            return Math.max(initialTime - elapsedTime, 0);
        }
        return initialTime;
    };
    

    // decrementa de 1 en 1
    const decreaseNum = () => {
        // setTiempo((prev) => prev - 1);
        setTiempo(calculateRemainingTime());
    }

    // realiza cuenta regresiva de 60 seg.
    const activarContador = () => {
        // setTiempo(initialTime)
        startTimeRef.current = Date.now();
        
        clearInterval(intervalRef.current);

        // intervalRef.current = setInterval(decreaseNum, 1000)
        intervalRef.current = setInterval(decreaseNum, 1000);
    }

    const restablecerContador = () =>{
        clearInterval(intervalRef.current)
        intervalRef.current = undefined
        setFormatTime( secsToMinSecs(0) )
    }

    useEffect(() => {
        if(play){
            activarContador()
        }
    }, [play]);

    // detiene el contador
    useEffect(() => {
        if(tiempo){
            setFormatTime( secsToMinSecs(tiempo) )
        }else{
            restablecerContador()
            setReset(true)
        }
    }, [tiempo]);

    return(
        <div className={formatTime !== '00:00' ? styles?.counterOTP : `${styles?.counterOTP } ${styles?.disabled }`}>{formatTime}</div>
    )
}

export default CounterTimeOTP